import React, { createContext, useContext } from 'react'

type TreatmentExpensesContextType = {
  treatmentExpensesType: string
  changeTreatmentExpensesType: (type: string) => void
}

export const TreatmentExpensesContext =
  createContext<TreatmentExpensesContextType>({
    treatmentExpensesType: '',
    changeTreatmentExpensesType: () => {},
  })

const TreatmentExpensesProvider = ({
  children,
}: React.PropsWithChildren<any>) => {
  const [treatmentExpensesType, changeTreatmentExpensesType] =
    React.useState<string>('')

  return (
    <TreatmentExpensesContext.Provider
      value={{
        treatmentExpensesType,
        changeTreatmentExpensesType,
      }}
    >
      {children}
    </TreatmentExpensesContext.Provider>
  )
}

export default TreatmentExpensesProvider
export const useTreatmentExpensesProvider = () =>
  useContext(TreatmentExpensesContext)
